import { SalesStage } from '../types/SalesStage';

export const isLeadPdfAvailable = (salesStage: SalesStage) =>
  !['roofer_picking', 'data_erased', 'give_away', 'Resubmission'].includes(
    salesStage,
  );
